import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import styles from './style.module.scss'
import { checkIsGlanceView, numberWithOrdinal } from '@shared/utils'
import InnerHTML from '@shared/components/InnerHTML'
import { getMatchPlayers } from '@shared/libs/match-detail'

const EndOver = dynamic(() => import('./endover'))
const GlanceAd = dynamic(() => import('@shared-components/ads/glanceAd'), { ssr: false })
const MatchXI = dynamic(() => import('../matchXI'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
const Ads = dynamic(() => import('@shared/components/ads'))

const Commentary = ({ data, matchDetail, playingXI }) => {
  const players = getMatchPlayers()
  const { t } = useTranslation()
  const router = useRouter()
  const isGlanceView = checkIsGlanceView(router?.query)

  function getClass(over) {
    if (over?.sScore === '0') {
      return `${styles.run} rounded-pill`
    } else if (over?.sScore === 'w') {
      return `${styles.run} rounded-pill bg-danger border-danger text-white text-uppercase`
    } else if (over?.sScore === '4') {
      return `${styles.run} rounded-pill bg-success border-success text-white`
    } else if (over?.sScore === '6') {
      return `${styles.run} ${styles.runPrimary} rounded-pill bg-primary text-white`
    } else if (over?.sScore !== 'w') {
      return `${styles.run} rounded-pill bg-info border-info`
    }
    return `${styles.run} rounded-pill bg-info border-info`
  }

  function getInningNumber(ind, ovr) {
    if (data?.[ind - 1]?.nInningNumber !== ovr?.nInningNumber) {
      return (
        <h3 className="text-uppercase small-head mt-md-3 mt-2 mt-md-3">
          {ovr?.nInningNumber}
          <sup className="text-lowercase">{numberWithOrdinal(ovr?.nInningNumber)}</sup> {t('common:Innings')}
        </h3>
      )
    } else return null
  }
  let latestOver = -1 // Track the last over where an ad was shown
  return (
    <>
      <div className={`${styles.commentary} br-md overflow-hidden`}>
        {data?.map((o, i) => {
          if (o?.eEvent === 'oe') {
            const currentOver = parseInt(o?.sOver, 10)

            // Update latestOver
            if (currentOver > latestOver) latestOver = currentOver
            return (
              <React.Fragment key={o?._id}>
                {getInningNumber(i, o)}
                {/* {lastAdOver} */}
                <EndOver data={o} id={o?._id} inning={matchDetail?.aInning} players={players} />
                {(currentOver === latestOver || currentOver === latestOver - 2) && (
                  <Ads
                    id={`div-ad-${matchDetail?._id}-${matchDetail?.nLatestInningNumber}-${o?.sOver}-${i}`}
                    adIdDesktop="Crictracker_New_Desktop_LiveScore_BTF_728x90"
                    adIdMobile="Crictracker_New_Mobile_LiveScore_BTF_300x250"
                    dimensionDesktop={[728, 90]}
                    dimensionMobile={[300, 250]}
                    mobile
                    className={'text-center'}
                  />
                )}
                {isGlanceView && Number(o?.sOver) % 2 === 0 && (
                  <>
                    <GlanceAd
                      id={`div-gpt-ad-156${new Date().getTime() * ((Math.random() + 1) * 1000)}`}
                      adId="Crictracker_mrec_bottom"
                      dimension={[[300, 250], [336, 280], 'fluid']}
                      className="mt-2 d-flex justify-content-center"
                      adUnitName="Crictracker_Sportstab_InArticleMedium_Mid3"
                      placementName="InArticleMedium"
                      width={300}
                      height={250}
                      pageName="Crictracker SportsTab"
                    />
                  </>
                )}
              </React.Fragment>
            )
          } else if (o?.eEvent === 'p11') {
            return (
              <React.Fragment key={o?._id}>
                {data?.length > 1 && <br />}
                <MatchXI
                  data={playingXI}
                  status={matchDetail?.sStatusStr}
                  isOutSideCountryPlane={matchDetail?.oSeries?._id === '63f052b9d5e097df610db62d'}
                />
              </React.Fragment>
            )
          } else {
            return (
              <React.Fragment key={o?._id}>
                {getInningNumber(i, o)}
                <div
                  id={o?._id}
                  className={`${styles.item} ${o?.eEvent === 'c' ? 'pb-0' : ''} common-box d-flex align-items-center rounded-0`}
                >
                  {o?.eEvent !== 'c' && (
                    <div className={`${styles.ball} d-flex flex-column flex-md-row-reverse align-items-center`}>
                      <div className={`${getClass(o)} text-center`}>{o?.sScore}</div>
                      <span className={`${styles.ballNo} fw-bold text-center text-md-start`}>
                        {o?.sOver}.{o?.sBall}
                      </span>
                    </div>
                  )}
                  <CommonContent isSmall>
                    <InnerHTML html={o?.sCommentary} />
                  </CommonContent>
                </div>
              </React.Fragment>
            )
          }
        })}
      </div>
    </>
  )
}

Commentary.propTypes = {
  data: PropTypes.array,
  id: PropTypes.string,
  matchDetail: PropTypes.object,
  playingXI: PropTypes.object,
  handleFilterChange: PropTypes.func
}

export default Commentary
